import { render, staticRenderFns } from "./RightSidebar.vue?vue&type=template&id=513c5c88&scoped=true"
import script from "./RightSidebar.vue?vue&type=script&lang=js"
export * from "./RightSidebar.vue?vue&type=script&lang=js"
import style0 from "./RightSidebar.vue?vue&type=style&index=0&id=513c5c88&prod&lang=scss&scoped=true"
import style1 from "./RightSidebar.vue?vue&type=style&index=1&id=513c5c88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513c5c88",
  null
  
)

export default component.exports